import { Chip, Grid } from '@mui/material'
import {
  ArrayInput,
  EditButton,
  NumberInput,
  required,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocale,
} from 'react-admin'
import { makeStyles } from 'tss-react/mui'
import { CompactRemoveButton, FormDataConsumer } from '~/components'

const useStyles = makeStyles()((theme) => ({
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    'margin-top': '-1em',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
}))

export const UpsertSection = ({ record, showI18n }) => {
  const { classes } = useStyles()
  const locale = useLocale()

  return (
    <Grid container spacing={3}>
      <Grid size={{ md: 3 }}>
        <TextInput source='slug' fullWidth disabled label='resources.sections.fields.slug' />
        {showI18n && (
          <TranslatableInputs locales={['de', 'en']} defaultLocale={locale} groupKey='name'>
            <TextInput source='translated_name' label='resources.sections.fields.name' fullWidth />
          </TranslatableInputs>
        )}
      </Grid>
      <Grid size={{ md: 3 }}>
        <NumberInput source='position' fullWidth />
      </Grid>
      <Grid size={{ md: 12 }}>
        <ArrayInput source='categories' label='resources.categories.title'>
          <SimpleFormIterator
            disableRemove={(r) => Number(r.id) > 0}
            removeButton={<CompactRemoveButton />}
          >
            <FormDataConsumer>
              {({ scopedFormData: { id, name, attributes } = {}, getSource, ...rest }) => (
                <Grid container spacing={1}>
                  <Grid size={{ md: 3 }}>
                    <TextInput
                      source={'name'}
                      validate={[required()]}
                      label='resources.categories.fields.name'
                      fullWidth
                      autoFocus={!name}
                    />
                    {showI18n && (
                      <TranslatableInputs
                        locales={['de', 'en']}
                        defaultLocale={locale}
                        groupKey={getSource('name')}
                      >
                        <TextInput
                          source={'translated_name'}
                          label='resources.categories.fields.name'
                          fullWidth
                        />
                      </TranslatableInputs>
                    )}
                  </Grid>
                  <Grid size={{ md: 6 }}>
                    <TextInput
                      source={'description'}
                      label='resources.categories.fields.description'
                      fullWidth
                    />
                    {showI18n && (
                      <TranslatableInputs
                        locales={['de', 'en']}
                        defaultLocale={locale}
                        groupKey={getSource('description')}
                      >
                        <TextInput
                          source={'translated_description'}
                          label='resources.categories.fields.description'
                          fullWidth
                        />
                      </TranslatableInputs>
                    )}
                  </Grid>
                  <Grid size={{ md: 3 }}>{id && <EditButton record={{ id: id }} />}</Grid>
                  <Grid size={{ md: 12 }}>
                    <div className={classes.chips}>
                      {attributes?.map((a) => (
                        <Chip key={a.id} label={a.name} />
                      ))}
                    </div>
                  </Grid>
                </Grid>
              )}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </Grid>
  )
}

export default UpsertSection
